<template>
  <a-modal
    :visible="visible"
    :title="title"
    @cancel="handleCancel"
    :width="form.replayType === 3 ? '900px' : '600px'"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="回放类型" prop="replayType">
        <a-select v-model="form.replayType" placeholder="请选择回放类型" @change="handleReplayTypeChange">
          <a-select-option :value="1">视频</a-select-option>
          <a-select-option :value="2">音频</a-select-option>
          <a-select-option :value="3">富文本</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.replayType === 1" label="上传视频" prop="replayUrl">
        <OssUploadSingle v-model="form.replayUrl" type="video" :maxSize="500" prefix="livecourse" />
        <div style="color: #999; font-size: 12px;">支持 mp4 格式，最大 500MB</div>
      </a-form-model-item>
      <a-form-model-item v-if="form.replayType === 1" label="视频方向" prop="screenOrientation">
        <a-select v-model="form.screenOrientation" placeholder="请选择视频方向">
          <a-select-option :value="1">竖屏</a-select-option>
          <a-select-option :value="2">横屏</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item v-if="form.replayType === 2" label="上传音频" prop="replayUrl">
        <a-upload
          :file-list="audioFileList"
          :remove="handleAudioRemove"
          :before-upload="beforeAudioUpload"
          :customRequest="customAudioRequest"
          accept="audio/*"
        >
          <a-button v-if="audioFileList.length === 0"> <a-icon type="upload" />选择音频文件</a-button>
        </a-upload>
        <div style="color: #999; font-size: 12px;">支持 mp3、wav 等音频格式，最大 100MB</div>
      </a-form-model-item>
      <a-form-model-item v-if="form.replayType === 3" label="富文本内容" prop="richContent">
        <Editor v-model="form.richContent" />
      </a-form-model-item>
      <a-form-model-item v-if="form.replayType !== 3" label="是否允许下载" prop="isAllowDownload">
        <a-select v-model="form.isAllowDownload" placeholder="请选择">
          <a-select-option :value="1">允许</a-select-option>
          <a-select-option :value="0">不允许</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button @click="handleCancel">取消</a-button>
      <a-button type="primary" @click="submitForm">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { addLiveCourseSectionReplay, updateLiveCourseSectionReplay } from '@/api/livecourse/liveCourseSectionReplay'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import Editor from '@/components/Editor'
import OssUploadSingle from '@/components/OssUploadSingle'

export default {
  name: 'ReplayCreateForm',
  components: { Editor, OssUploadSingle },
  props: {
    sectionId: {
      type: [String, Number],
      default: null
    },
    liveId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      form: {
        id: undefined,
        sectionId: undefined,
        liveId: undefined,
        replayUrl: undefined,
        replayType: undefined,
        richContent: undefined,
        isAllowDownload: 0,
        screenOrientation: 1
      },
      rules: {
        replayType: [{ required: true, message: '请选择回放类型', trigger: 'change' }]
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      audioFileList: []
    }
  },
  methods: {
    handleAdd() {
      this.title = '新增回放'
      this.form = {
        id: undefined,
        sectionId: this.sectionId,
        liveId: this.liveId,
        replayUrl: undefined,
        replayType: undefined,
        richContent: undefined,
        isAllowDownload: 0,
        screenOrientation: 1
      }
      this.audioFileList = []
      this.visible = true
    },
    handleUpdate(row) {
      this.title = '修改回放'
      this.form = { ...row }
      if (this.form.screenOrientation == null) {
        this.form.screenOrientation = 1
      }
      this.audioFileList = []
      if (row.replayUrl) {
        this.audioFileList = [{
          uid: '-1',
          name: row.replayUrl.substring(row.replayUrl.lastIndexOf('/') + 1),
          status: 'done',
          url: row.replayUrl
        }]
      }
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.audioFileList = []
    },
    handleReplayTypeChange(value) {
      if (value === 3) {
        this.form.replayUrl = undefined
        this.form.isAllowDownload = 0
      } else {
        this.form.richContent = undefined
      }
      this.audioFileList = []
    },
    beforeAudioUpload(file) {
      const isAudio = file.type.startsWith('audio/')
      if (!isAudio) {
        this.$message.error('只能上传音频文件!')
        return false
      }
      const isLt100M = file.size / 1024 / 1024 < 100
      if (!isLt100M) {
        this.$message.error('音频文件大小不能超过 100MB!')
        return false
      }
      return true
    },
    customAudioRequest(fileInfo) {
      const uploadFile = fileInfo.file
      const prefix = 'livecourse/audio'
      const suffix = uploadFile.name.substring(uploadFile.name.lastIndexOf('.'))
      const url = generateFilePath(prefix, suffix)
      uploadObject(url, uploadFile).then(res => {
        this.audioFileList = [{
          uid: '-1',
          name: uploadFile.name,
          status: 'done',
          url: res
        }]
        this.form.replayUrl = res
        this.$message.success('上传成功')
      })
    },
    handleAudioRemove() {
      this.audioFileList = []
      this.form.replayUrl = undefined
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.replayType === 1 && !this.form.replayUrl) {
            this.$message.warning('请上传视频')
            return
          }
          if (this.form.replayType === 2 && !this.form.replayUrl) {
            this.$message.warning('请上传音频')
            return
          }
          if (this.form.replayType === 3 && !this.form.richContent) {
            this.$message.warning('请输入富文本内容')
            return
          }
          if (this.form.id) {
            updateLiveCourseSectionReplay(this.form).then(() => {
              this.$message.success('修改成功')
              this.visible = false
              this.$emit('ok')
            })
          } else {
            addLiveCourseSectionReplay(this.form).then(() => {
              this.$message.success('新增成功')
              this.visible = false
              this.$emit('ok')
            })
          }
        }
      })
    }
  }
}
</script>
